import React, { useEffect, useCallback, useState} from 'react';
import {EFFECT_PARAMETER, PARAMETER_VALUE} from 'constants/contextual-help.js';
import Tone from 'tone';
import Documented from "components/help/Documented.js"

import {connect} from 'react-redux';

const ParameterLabel = ({displayFunction, unit, isParameter, parameter, onEdit, value, ... props}) => { 
    const convertValue = useCallback(() => {
        if (value === undefined || value === null) {
            return 0;
        }
        if (typeof value === 'object') {
            if (value.toSeconds) {
                return value.toSeconds();
            } else if (value._val) {
                return new Tone.Time(value._val).toSeconds();
            }
        } else if (typeof value === 'string') {
            return new Tone.Time(value).toSeconds();
        }
        return value;
    }, [value]);
 
    const getValue = useCallback(() => {
        let _value = convertValue();
        let value = _value !== undefined ? _value:
            isParameter ? parameter.get() :
            props.getValue();
        return value;
    }, [parameter, value]);

    unit = unit || '';
    const displayValue = (
        displayFunction === undefined ?
            round(value) :
            displayFunction(getValue())) + ' ' +
          unit;

    return (
        <Documented
          element={PARAMETER_VALUE}
          className="pushable parameter-label-value"
          onClick={(e) => onEdit(e)}>
          {props.convertToRoot ? Math.round(Math.log2(displayValue)) : displayValue}
        </Documented>);
}

const mapStateToProps = (state, props) => {
    if (!props.parameter) { return undefined; }
    let val = state.effects.effectParameters[props.parameter.id];
  return {
        value: val === undefined ? props.parameter.get(true) : val,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

function round(value) {
    return Math.round(value * 1000) / 1000;
}

export default connect(mapStateToProps, mapDispatchToProps)(ParameterLabel);
